import React from 'react';
import { Heart } from 'lucide-react';
import clsx from 'clsx';
import { useWatchlist } from '../../contexts/WatchlistContext';

/**
 * Heart icon — clicked to add/remove from watchlist. Pure presentation.
 * `propertyId` required, `size` optional, `variant` controls the chrome
 * (compact for cards, large for detail page).
 */
export default function WatchlistButton({ propertyId, size = 16, variant = 'compact', className = '' }) {
  const { isInWatchlist, toggle } = useWatchlist();
  const inList = isInWatchlist(propertyId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(propertyId);
  };

  if (variant === 'large') {
    return (
      <button
        type="button"
        onClick={onClick}
        title={inList ? 'Remove from watchlist' : 'Add to watchlist'}
        className={clsx(
          'inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors border',
          inList
            ? 'bg-rose-500/15 text-rose-300 border-rose-500/30 hover:bg-rose-500/25'
            : 'bg-slate-800 text-slate-300 border-slate-700 hover:border-slate-600',
          className,
        )}
      >
        <Heart size={size} fill={inList ? 'currentColor' : 'none'} />
        {inList ? 'In your watchlist' : 'Add to watchlist'}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={inList ? 'Remove from watchlist' : 'Add to watchlist'}
      className={clsx(
        'inline-flex items-center justify-center w-7 h-7 rounded-md transition-colors',
        inList
          ? 'text-rose-400 hover:bg-rose-500/15'
          : 'text-slate-500 hover:text-slate-200 hover:bg-slate-800',
        className,
      )}
    >
      <Heart size={size} fill={inList ? 'currentColor' : 'none'} />
    </button>
  );
}
